// IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, проверка dev02 22:19 п.2.2: грид вкладки Transitions записи 0GJ_001 пуст 30–48 с после первого клика, строки — со второго).
// Замер ботом (handoff-tools/2026-10-16/transitions_perf, пробы 3–9, холодное открытие записи после входа): ответ approval_transitions_rows приходит за 0,06 с
// бэка / 1,8 с сети, record._doc.approval_transitions = 43 строки через 2 с, но (1) запрос ленивой вкладки уходит ТРИ раза (клик; initialized новой панели →
// content_Changed → восстановление вкладки _keep; lhMounted новой панели) и (2) зарегистрированный экземпляр грида после клика — НОВЫЙ, его $el не в документе
// (поддерево вкладки пересоздано в отцепленный DOM), а видимый грид в DOM — без живого владельца; содержимое чинит только повторный клик (reveal).
// Правило: (а) запрос ленивой вкладки по одной привязке не дублируется, пока предыдущий в пути (окно IN_FLIGHT_MS); (б) после прихода данных ленивой
// вкладки панель проверяет свой грид: отцеплен от документа — вкладка перемонтируется (openedTabs выкл → вкл), смонтирован и скрыт — показывается
// (handleVisibility). Флаг fe.ux.lazyTabReveal (дефолт ВКЛ). Тест: tests/unit/lazyTabReveal.test.mjs
export const LAZY_TAB_REVEAL_FLAG = 'fe.ux.lazyTabReveal'
export const IN_FLIGHT_MS = 15000

export function lazyTabReveal_on(setting) {
    try { return typeof setting !== 'function' || setting(LAZY_TAB_REVEAL_FLAG, true) !== false } catch (e) { return true }
}

// привязка из обновления ответа (updates[].binding: 'record._doc.x' | '_doc.x') → '_doc.x'; не ленивая (_doc.*) — ''
export function lazyTab_binding(binding) {
    const b = String(binding == null ? '' : binding).replace(/^record\./, '')
    return b.startsWith('_doc.') ? b : ''
}

// можно ли слать запрос ленивой вкладки сейчас: inFlight — {binding: ts отправки}; now — Date.now(). Да — отметка ставится
export function lazyTab_canSend(inFlight, binding, now = Date.now()) {
    if (!inFlight || typeof inFlight !== 'object' || !binding) return true
    const ts = Number(inFlight[binding])
    if (Number.isFinite(ts) && ts > 0 && now - ts < IN_FLIGHT_MS) return false
    inFlight[binding] = now
    return true
}

// атрибуты-гриды вкладки по привязке (рекурсивно по attrs)
export function lazyTab_gridAttrs(attrTab, binding, out = []) {
    for (const a of (attrTab && Array.isArray(attrTab.attrs) ? attrTab.attrs : [])) {
        if (!a || typeof a !== 'object') continue
        if (a.binding === binding && (a.attr_type === 'AttrGrid' || a.component === 'AttrGrid')) out.push(a)
        if (Array.isArray(a.attrs)) lazyTab_gridAttrs(a, binding, out)
    }
    return out
}

// решение после прихода данных: grids — живые экземпляры грида привязки (реестр attrs_vueObj + _attrsLive) как
// [{attached: $el в документе, visible: $el на экране (offsetParent), isVisible: грид считает себя видимым, empty: строк в гриде нет, has: строки в записи есть}]
//   'remount' — ни одного экземпляра в документе (поддерево отцеплено): вкладку перемонтировать;
//   'reveal'  — есть экземпляр в документе и на экране, который себя ещё не показал (isVisible false) или пуст при пришедших строках: content_Changed + handleVisibility(true);
//   ''        — ничего не делать (грид уже живой либо гридов нет)
export function lazyTab_recovery(grids) {
    const list = Array.isArray(grids) ? grids.filter(g => g && typeof g === 'object') : []
    if (!list.length) return ''
    const attached = list.filter(g => g.attached)
    if (!attached.length) return 'remount'
    if (attached.some(g => g.visible && (g.isVisible === false || (g.empty === true && g.has === true)))) return 'reveal'
    return ''
}

// экземпляры грида, которые оживляются при 'reveal' (в документе и на экране)
export function lazyTab_revealTargets(grids) {
    return (Array.isArray(grids) ? grids : []).filter(g => g && g.attached && g.visible && (g.isVisible === false || (g.empty === true && g.has === true)))
}
